import Input from "../../components/InputBox";
import Select from "../../components/SelectInput";
import { useEffect } from "react";
import { countryList } from "../../data/static";

const countryOptions = countryList;

const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];

const AddressPage = ({ formData, setFormData, dataFor }) => {

    // Transform API operational hours data to the format expected by the form
    const transformOperationalHours = (apiData) => {
        // Create an empty operational hours object
        const transformedHours = {};
        
        // If API data has operational hours array
        if (apiData && apiData.operationalHours && Array.isArray(apiData.operationalHours)) {
            // Process each day in the array
            apiData.operationalHours.forEach(dayData => {
                // Convert dayRange to proper case (e.g., "MONDAY" to "Monday")
                const day = dayData.dayRange.charAt(0) + dayData.dayRange.slice(1).toLowerCase();
                
                transformedHours[day] = {
                    isOpen: true, // Since it exists in the array, it's open
                    open: dayData.timeRange?.open || "",
                    close: dayData.timeRange?.close || ""
                };
            });
        }
        
        return transformedHours;
    };
    
    // Use effect to transform data when formData changes
    useEffect(() => {
        if (formData && formData.operationalHours && Array.isArray(formData.operationalHours) && 
            formData.operationalHours.length > 0 && !formData.operationalHoursTransformed) {
            const transformedHours = transformOperationalHours(formData);
            setFormData(prevData => ({
                ...prevData,
                operationalHours: transformedHours,
                operationalHoursTransformed: true // Flag to prevent infinite loop
            }));
        }
    }, [formData, setFormData]); // Add formData as dependency to run when it changes

    const onChange = (e) => {
        const { name, value, type, checked, dataset } = e.target;
        if (dataset.day) {
            // Handle operationalHours
            setFormData({
                ...formData,
                operationalHours: {
                    ...formData.operationalHours,
                    [dataset.day]: {
                        ...formData.operationalHours?.[dataset.day],
                        [name]: type === "checkbox" ? checked : value
                    }
                }
            });
        } else {
            setFormData({ ...formData, address : {...formData?.address, [name]: value} });
        }
    }

    return (
        <div className="card_content">
            <h4>Step 3: Address</h4>
            <p>Fill all the mandatory fields details here.</p>
            <div className="card_container">
                <Input isRequired className={"input"} label="Address 1" name={`${dataFor}_address1`} value={formData?.address?.[`${dataFor}_address1`]} onChange={onChange} />
                <Input isRequired className={"input"} label="Address 2" name={`${dataFor}_address2`} value={formData?.address?.[`${dataFor}_address2`]} onChange={onChange} />
                <Input isRequired className={"input"} label="City" name={`${dataFor}_city`} value={formData?.address?.[`${dataFor}_city`]} onChange={onChange} />
                <Input isRequired className={"input"} label="State" name={`${dataFor}_state`} value={formData?.address?.[`${dataFor}_state`]} onChange={onChange} />
                <Input isRequired className={"input"} label="Post Code" name={`${dataFor}_postCode`} value={formData?.address?.[`${dataFor}_postCode`]} onChange={onChange} />
                <Select
                    isRequired
                    options={countryOptions}
                    placeholder="Select Country"
                    selectedValue={formData?.address?.[`${dataFor}_country`]}
                    className="select-input"
                    label={"Country"}
                    name={`${dataFor}_country`}
                    value={formData?.address?.[`${dataFor}_country`] || ""}
                    onChange={onChange}
                />
            </div>
            {dataFor === "partner" &&(  <span className="form_title">Operational Days & Hours</span>)}
            {dataFor === "partner" && (
                
                <div className="operational-days">
                    
                    {daysOfWeek.map(day => (
                        
                        <div key={day} className="mb-2 d-flex align-items-center gap-2">
                            <input
                                type="checkbox"
                                name="isOpen"
                                data-day={day}
                                checked={formData?.operationalHours?.[day]?.isOpen || false}
                                onChange={onChange}
                            />
                            <label className="me-2 mb-0" style={{ minWidth: 80 }}>{day}</label>
                            <input
                                type="time"
                                name="open"
                                data-day={day}
                                value={formData?.operationalHours?.[day]?.open || ""}
                                onChange={onChange}
                                disabled={!formData?.operationalHours?.[day]?.isOpen}
                            />
                            <span>-</span>
                            <input
                                type="time"
                                name="close"
                                data-day={day}
                                value={formData?.operationalHours?.[day]?.close || ""}
                                onChange={onChange}
                                disabled={!formData?.operationalHours?.[day]?.isOpen}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default AddressPage;